export const calendarHourHeight = 64;

export function startOfWeek(value: Date) {
  const result = new Date(value);
  result.setHours(0, 0, 0, 0);
  const mondayOffset = (result.getDay() + 6) % 7;
  result.setDate(result.getDate() - mondayOffset);
  return result;
}

export function daysOfWeek(value: Date) {
  const start = startOfWeek(value);
  return Array.from({ length: 7 }, (_, index) => {
    const day = new Date(start);
    day.setDate(start.getDate() + index);
    return day;
  });
}

export function dayKey(value: Date) {
  return [
    value.getFullYear(),
    String(value.getMonth() + 1).padStart(2, "0"),
    String(value.getDate()).padStart(2, "0"),
  ].join("-");
}

export function minutesOfDay(value: Date) {
  return value.getHours() * 60 + value.getMinutes();
}

export function appointmentPosition(startsAt: Date, endsAt: Date) {
  const top = minutesOfDay(startsAt) / 60 * calendarHourHeight;
  const durationMinutes = Math.max(
    15,
    (endsAt.getTime() - startsAt.getTime()) / 60_000,
  );
  return {
    top,
    height: Math.max(30, durationMinutes / 60 * calendarHourHeight),
  };
}

export function snappedMinutes(offsetPixels: number) {
  const rawMinutes = offsetPixels / calendarHourHeight * 60;
  return Math.min(
    23 * 60 + 45,
    Math.max(0, Math.round(rawMinutes / 15) * 15),
  );
}

export function dropStartMinutes(
  offsetPixels: number,
  durationMinutes: number,
) {
  const duration = Math.max(15, durationMinutes);
  const latestStart = Math.max(0, 24 * 60 - duration);
  const snappedLatestStart = Math.floor(latestStart / 15) * 15;
  return Math.min(snappedMinutes(offsetPixels), snappedLatestStart);
}
